<template>
	<Page class="page">
		<template #empty>
			<Swiper effect="slide" :grabCursor="true" :modules="modules" :pagination="true">
				<SwiperSlide>
					<div class="swiper-slide-image" :style="{ backgroundImage: 'url(' + frame1 + ')' }" />
					<div class="swiper-slide-text">
						<BaseTypography size="xl" weight="semi-bold">Slider Title</BaseTypography>
						<BaseTypography size="l">
							AuraWallet - the first and only Waves wallet in Telegram, combining convenience, security,
							and powerful features for interacting with the blockchain ecosystem.
						</BaseTypography>
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div class="swiper-slide-image" :style="{ backgroundImage: 'url(' + frame2 + ')' }" />
					<div class="swiper-slide-text">
						<BaseTypography size="xl" weight="semi-bold">Slider Title</BaseTypography>
						<BaseTypography size="l">
							AuraWallet has APPS, a “mini app store” that will collect the most popular apps, bots and
							games from the Waves ecosystem. This is a very easy entry into the ecosystem for new users.
						</BaseTypography>
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div class="swiper-slide-image" :style="{ backgroundImage: 'url(' + frame3 + ')' }" />
					<div class="swiper-slide-text">
						<BaseTypography size="xl" weight="semi-bold">Slider Title</BaseTypography>
						<BaseTypography size="l">
							Fast and safe SWAP is always close at hand and in a couple of clicks. You'll love it.
						</BaseTypography>
					</div>
				</SwiperSlide>
			</Swiper>
		</template>

		<template #footer>
			<RouterLink to="/import" class="flex f-column">
				<ButtonMain variant="link">Import</ButtonMain>
			</RouterLink>
			<RouterLink to="/create" class="flex f-column">
				<ButtonMain>Create</ButtonMain>
			</RouterLink>
		</template>
	</Page>
</template>

<script setup lang="ts">
import ButtonMain from '@/components/ui/BaseButton.vue';
import frame1 from '@/assets/images/frame-1.png';
import frame2 from '@/assets/images/frame-2.png';
import frame3 from '@/assets/images/frame-3.png';
import Page from '@/components/ui/Page.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import { ref } from 'vue';
import BaseTypography from '@/components/ui/BaseTypography.vue';

const modules = ref([Pagination]);
</script>

<style scoped>
.page {
	height: 100svh !important;
}

.swiper {
	user-select: none;
	height: 100%;
}

.swiper-slide {
	display: flex;

	box-sizing: border-box;

	padding-bottom: 30px;
	width: 100% !important;
	flex-direction: column;

	height: 100% !important;
}

.swiper-slide-image {
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;

	flex: 1;
}
.swiper-slide-text {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;

	margin-top: auto;
}

::v-deep(.swiper-pagination-horizontal) {
	display: flex;
	align-items: center;
	justify-content: center;
}

::v-deep(.swiper-pagination-bullet) {
	width: 6px !important;
	height: 6px !important;
	background: rgba(255, 255, 255, 0.6) !important;
}

::v-deep(.swiper-pagination-bullet-active) {
	width: 10px !important;
	height: 10px !important;
	background: #fff !important;
}
</style>
